import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Beaker: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4.5 3h15' }],
    ['path', { d: 'M6 3v16a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V3' }],
    ['path', { d: 'M6 14h12' }],
  ],
];

export default Beaker;
